import { useEffect, useState } from 'react'

import type { ParsedUrlQuery } from 'querystring'

const useMateriRouterCheck = (
  isRouterReady: boolean,
  query: ParsedUrlQuery
) => {
  const [routerQueryIsNotComplete, setRouterQueryIsNotComplete] =
    useState(false)
  useEffect(() => {
    if (isRouterReady && (!query.modul || !query.materi)) {
      setRouterQueryIsNotComplete(true)
    }
  }, [query, isRouterReady])
  return routerQueryIsNotComplete
}

export default useMateriRouterCheck
